/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ReportFilterModelWireFileFilterModelDto,
  WireFileFilterModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class WireFileUploadReportClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags WireFileUploadReport
   * @name WireFileUploadReportWireFileUploadReport
   * @summary Returns the wire file upload report results based on the parameters of the filter
   * @request POST:/WireFileUploadReport
   */
  wireFileUploadReportWireFileUploadReport = (
    data: WireFileFilterModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/WireFileUploadReport`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags WireFileUploadReport
   * @name WireFileUploadReportSaveWireFileUploadReport
   * @summary Saves the WireFileFilterModel as a custom report
   * @request PUT:/WireFileUploadReport
   */
  wireFileUploadReportSaveWireFileUploadReport = (
    data: ReportFilterModelWireFileFilterModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/WireFileUploadReport`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags WireFileUploadReport
   * @name WireFileUploadReportGetWireFileUploadReport
   * @summary Retrieves a saved WireFileFilterModel
   * @request GET:/WireFileUploadReport
   */
  wireFileUploadReportGetWireFileUploadReport = (
    query?: {
      /**
       * The id of the report to retrieve
       *
       * @format int32
       */
      reportId?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/WireFileUploadReport`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags WireFileUploadReport
   * @name WireFileUploadReportDownloadWireFileUploadReport
   * @summary Download the results of the wire file upload report in a supported format
   * @request POST:/WireFileUploadReport/Download
   */
  wireFileUploadReportDownloadWireFileUploadReport = (
    data: WireFileFilterModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/WireFileUploadReport/Download`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
